export const MEMBER_SERVICES_PHONE_NUMBER = '855-563-2639';

export const memberServicesPhone = (employerPhone?: string | null) => {
  const trimmed = employerPhone?.trim();

  return trimmed || MEMBER_SERVICES_PHONE_NUMBER;
};

export const memberServicesPhoneHref = (phone: string) => `tel://${phone}`;
